<template>
  <div class="contact-card">
    <va-card title="Contact">
      <div class="contact-us">
        Reach out to discuss your training goals or any questions you may have.
        We look forward to hearing from you!
      </div>
      <contact-form />
      <div class="send-email">
        Shoot us an email at <a
          href="mailto:rewardingdogtrain@gmail.com"
          target="_blank"
          class="app-navbar__mailto-link"
          :style="{color: this.$themes.primary}"
        >
          rewardingdogtrain@gmail.com
        </a>
      </div>
      <!-- <div class="social-media">
        Connect with us!
      </div> -->
      <!-- <div class="social-media-icons">
        <a href="https://fb.me/RewardingDogTraining" target="_blank" aria-label="facebook">
          <va-icon name="brandico brandico-facebook-rect" />
        </a>
        <a href="https://www.instagram.com/rewardingdogtraining/" target="_blank" aria-label="instagram">
          <va-icon name="brandico brandico-instagram-filled" />
        </a>
      </div> -->
    </va-card>
  </div>
</template>

<script>
import ContactForm from '../forms/ContactForm'

export default {
  name: 'contact-card',
  components: {
    ContactForm,
  },
}
</script>

<style lang="scss">
.contact-card {
  @include media-breakpoint-up(md) {
    min-width: 700px;
  }

  .contact-us {
    text-align: center;
    margin-bottom: 2rem;
  }

  .send-email {
    text-align: center;
    margin: 2rem 0 1rem;
  }

  .social-media-icons {
    font-size: 2.4rem;

    a {
      color: $gray;

      :hover {
        filter: brightness(30%);
      }

      i {
        margin: 0 1rem 1rem;
      }
    }
  }
}
</style>
